import { axios, Response } from '../index'

const movePersonaFiles = (
  from: string,
  filesIds: string[],
  to?: string
): Response<null> => {
  return axios.put(`/v1/folders/${from}/${to}`, { filesIds })
}

export default movePersonaFiles
